import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing16, spacing8 } from 'approot/shared/styles/spacing.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';

export const baseContentCardButtons = css`
  position: absolute;
  top: 0;
  right: 0;
  padding: ${rem(spacing16)};
  z-index: 3;
`;

export const ContentCardButtonsWrapper = styled.div`
  ${baseContentCardButtons}

  ${baseFlexCss}
  gap: ${rem(spacing8)};
`;
